const API_BASE_URL = process.env.REACT_APP_API_URL;
const TAREAS_ENDPOINT = `${API_BASE_URL}tareas`;

// Obtener tarea por ID (GET /api/tareas/{id})
export const getTareaById = async (tareaId) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const baseUrl = API_BASE_URL || 'http://localhost:5164/api/';
    const url = `${baseUrl}tareas/${tareaId}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener la tarea.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener la tarea por ID:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const crearTarea = async (tareaData) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      console.error('Token no encontrado.');
      return { success: false, message: 'Token no encontrado. Por favor, inicie sesión.' };
    }

    // Crear FormData para enviar archivos
    const formData = new FormData();
    
    // Agregar campos del formulario
    formData.append('areaId', tareaData.areaId);
    formData.append('categoriaId', tareaData.categoriaId);
    if (tareaData.subcategoriaId) {
      formData.append('subcategoriaId', tareaData.subcategoriaId);
    }
    if (tareaData.sedeId) {
      formData.append('sedeId', tareaData.sedeId);
    }
    if (tareaData.servicioId) {
      formData.append('servicioId', tareaData.servicioId);
    }
    formData.append('observaciones', tareaData.observaciones);

    // Agregar archivos
    if (tareaData.documentos && tareaData.documentos.length > 0) {
      for (let i = 0; i < tareaData.documentos.length; i++) {
        formData.append('documentos', tareaData.documentos[i]);
      }
    }

    // Debug: mostrar qué se está enviando
    console.log('Payload enviado:', tareaData);
    console.log('FormData creado:');
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    const response = await fetch(TAREAS_ENDPOINT, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        // 'Content-Type': 'multipart/form-data' // No es necesario establecerlo manualmente con FormData
      },
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      console.error('Error en la petición de creación de tarea:', response.status, errorData);
      console.error('Detalles del error:', errorData.errors);
      
      // Intentamos obtener un mensaje de error más específico del backend
      let specificMessage = 'Error al crear la tarea.';
      if (errorData.errors) {
        // Mostrar todos los errores de validación
        const errorMessages = Object.entries(errorData.errors).map(([field, messages]) => 
          `${field}: ${Array.isArray(messages) ? messages.join(', ') : messages}`
        );
        specificMessage = errorMessages.join('; ');
      } else if (errorData.message) {
        specificMessage = errorData.message;
      }
      
      return { success: false, message: specificMessage };
    }

    const responseData = await response.json();
    return { success: true, data: responseData };

  } catch (error) {
    console.error('Error al crear la tarea:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const getTareasPorUsuario = async (usuarioId) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/usuario/${usuarioId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener las tareas.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener las tareas:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const getTareasPorAreaAdmin = async () => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/admin/area`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener las tareas del área.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener las tareas del área:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const crearComentario = async (tareaId, comentario) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/comentario`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        tareaId,
        comentario
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al crear el comentario.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al crear el comentario:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
}; 
// Nueva función para obtener los comentarios de una tarea
export const getComentariosPorTarea = async (tareaId) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/${tareaId}/comentarios`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener los comentarios.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener los comentarios:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
}; 

// Cambiar el estado de una tarea (PUT /api/tareas/{tareaId}/estado)
export const updateEstadoTarea = async (tareaId, nuevoEstadoId) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/${tareaId}/estado`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ NuevoEstadoId: nuevoEstadoId }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al cambiar el estado de la tarea.' };
    }

    if (response.status === 204) {
      return { success: true, data: null };
    }
    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al cambiar el estado de la tarea:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
}; 

// Cambiar la prioridad de una tarea (PUT /api/tareas/{tareaId}/prioridad)
export const updatePrioridadTarea = async (tareaId, prioridadId) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/${tareaId}/prioridad`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ prioridadId }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al cambiar la prioridad de la tarea.' };
    }

    if (response.status === 204) {
      return { success: true, data: null };
    }
    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al cambiar la prioridad de la tarea:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
}; 

// Cambiar el área de una tarea (PUT /api/tareas/{tareaId}/area)
export const updateAreaTarea = async (tareaId, areaId) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/${tareaId}/area`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ areaId }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al cambiar el área de la tarea.' };
    }

    if (response.status === 204) {
      return { success: true, data: null };
    }
    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al cambiar el área de la tarea:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
}; 

// Cambiar la categoría de una tarea (PUT /api/tareas/{tareaId}/categoria)
export const updateCategoriaTarea = async (tareaId, nuevaCategoriaId) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/${tareaId}/categoria`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ NuevaCategoriaId: nuevaCategoriaId }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al cambiar la categoría de la tarea.' };
    }

    if (response.status === 204) {
      return { success: true, data: null };
    }
    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al cambiar la categoría de la tarea:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

// Cambiar la calificación de una tarea (PUT /api/tareas/{tareaId}/calificacion)
export const updateCalificacionTarea = async (tareaId, calificacion, comentario) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/${tareaId}/calificacion`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ calificacion, comentario }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al calificar la tarea.' };
    }

    if (response.status === 204) {
      return { success: true, data: null };
    }
    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al calificar la tarea:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
}; 

// Obtener estadísticas de tareas por usuario (GET /api/tareas/estadisticas/{usuarioId})
export const getEstadisticasTareas = async (usuarioId) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/estadisticas/${usuarioId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener las estadísticas de tareas.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener las estadísticas de tareas:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

// Editar calificación de una tarea (PUT /api/tareas/calificacion/{calificacionId}/editar)
export const editarCalificacionTarea = async (calificacionId, calificacion, comentario) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/calificacion/${calificacionId}/editar`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        calificacion: calificacion,
        comentario: comentario
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al editar la calificación de la tarea.' };
    }

    // Si la respuesta es exitosa pero no tiene contenido JSON (status 204)
    if (response.status === 204 || response.headers.get('content-length') === '0') {
      return { success: true, data: null };
    }

    // Intentar parsear JSON solo si hay contenido
    try {
      const data = await response.json();
      return { success: true, data };
    } catch (error) {
      // Si no hay JSON válido pero la respuesta fue exitosa
      return { success: true, data: null };
    }
  } catch (error) {
    console.error('Error al editar la calificación de la tarea:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
}; 

// Función para obtener tareas con comentarios no leídos
export async function getTareasConComentariosNoLeidos(userId) {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      throw new Error('No hay token de autenticación');
    }

    // URL base - usar hardcodeada temporalmente si no hay variable de entorno
    const baseUrl = API_BASE_URL || 'http://localhost:5164/api/';
    const url = `${baseUrl}tareas/comentarios-no-leidos/${userId}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Error HTTP: ${response.status}`);
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener tareas con comentarios no leídos:', error);
    return { success: false, message: error.message };
  }
} 